export default __webpack_public_path__ + "static/nz-a61b860aa3ea45de9dcccebf987df30c.svg";